import React from 'react';
import { SideContainerWrapper } from '../../../styles/sideContainerStyles';

import { ReactComponent as VenderIllustration } from '../../../../assets/rebranding/institucional/vender.svg';
import { List, ListItem, Title } from '@icarros/ids-react';
import { usePerformanceContext } from '../../../store/contexts/performance';
import { PERFORMANCE_TIPS } from '../constants';
import { ListItemModifier, TitleModifier } from '../style';

export function Improvements(): JSX.Element {
  const { qualityTips } = usePerformanceContext();

  const DYNAMIC_FIPE_REGEX = 'tabela fipe';
  const fipeContent = qualityTips.data?.find(quality =>
    quality.toLowerCase().includes(DYNAMIC_FIPE_REGEX)
  );

  return (
    <SideContainerWrapper isOpen={false} isTransition={false} showOnMobile>
      <VenderIllustration />
      <TitleModifier>
        <Title size="overline">anúncio de qualidade</Title>
      </TitleModifier>
      <Title>melhore seu anúncio para conseguir vender mais rápido</Title>
      <List>
        <>
          {PERFORMANCE_TIPS.map(({ description, icon }) => (
            <ListItemModifier key={description} isHighlight>
              <ListItem label={description} avatarIcon={icon} avatarVariant="icon" />
            </ListItemModifier>
          ))}
          {fipeContent ? (
            <ListItemModifier isHighlight>
              <ListItem label={fipeContent} avatarIcon="itaufonts_consorcio" avatarVariant="icon" />
            </ListItemModifier>
          ) : (
            <></>
          )}
        </>
      </List>
    </SideContainerWrapper>
  );
}
